var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimplaz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6487 3.34766C10.7149 3.34766 9.14258 4.9307 9.14258 6.87755V10.4074H18.4938C20.4275 10.4074 21.9999 8.8244 21.9999 6.87755V3.34766H12.6487ZM20.8312 6.87755C20.8312 8.17545 19.7829 9.23081 18.4938 9.23081H10.3113V6.87755C10.3113 5.57965 11.3595 4.52429 12.6487 4.52429H20.8312V6.87755Z",
    fill: "url(#paint0_linear_943_16363)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34717 15.1504V18.6803C3.34717 20.6271 4.91954 22.2102 6.85326 22.2102H21.9991V18.6803C21.9991 16.7334 20.4267 15.1504 18.493 15.1504H3.34717ZM4.51586 16.327H18.493C19.7822 16.327 20.8304 17.3824 20.8304 18.6803V21.0335H6.85326C5.56411 21.0335 4.51586 19.9782 4.51586 18.6803V16.327Z",
    fill: "url(#paint1_linear_943_16363)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_16363",
    x1: 4.51337,
    y1: 6.87755,
    x2: 18.7558,
    y2: 6.87755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_16363",
    x1: 4.07476,
    y1: 18.6803,
    x2: 19.9742,
    y2: 18.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplaz);
export default __webpack_public_path__ + "static/media/simplaz.510fe063dbdbf805d019fce8f7f553f4.svg";
export { ForwardRef as ReactComponent };